export const counterMixin = {
  data() {
    return {
      formatSeconds(num) {
        const seconds = num % 60;
        const minutes = Math.floor(num / 60);
        const selectedTime = `${minutes < 10 ? '0' : ''}${minutes.toString()}:${
          seconds < 10 ? '0' : ''
        }${seconds.toString()}`;
        return num > 0 ? selectedTime : '0:00';
      },
      abbreviatedTime(num) {
        let displayTime;
        const seconds = num % 60;
        const minutes = Math.floor(num / 60);

        if (minutes) {
          displayTime = `${minutes.toString()}`;
        } else if (seconds && seconds > 0) {
          displayTime = `${seconds.toString()}`;
        } else {
          displayTime = 'N/A';
        }
        return displayTime;
      },
      stringToSeconds(val) {
        return val.split(':').reduce((acc, time) => 60 * acc + +time);
      },
      timeUnit(seconds) {
        if (seconds > 0 && seconds < 60) {
          return 'Seconds';
        }
        if (seconds >= 60) {
          return 'Minutes';
        }
      },
      removeZeros(val) {
        return val.replace(/0|:/g, '');
      },
      formatPrepTime(prepTime) {
        let displayTime;

        if (prepTime) {
          const time = prepTime.replace(/PT/g, '');

          if (time.includes('H')) {
            const timeArr = time.split('H');

            if (timeArr[0] === '0') {
              const minutes = timeArr[1].slice(0, -1);
              displayTime = `${minutes} min`;
            } else {
              displayTime = timeArr.join('H ');
            }
          } else {
            const minutes = time.slice(0, -1);
            displayTime = `${minutes} min`;
          }
          return displayTime;
        } else {
          return 'N/A';
        }
      },
      prepHours(prepTime) {
        if (prepTime) {
          const time = prepTime.replace(/PT/g, '');
          return time.includes('H') ? time.split('H')[0] : 0;
        }
      },
      prepMinutes(prepTime) {
        if (prepTime) {
          const time = prepTime.replace(/PT/g, '');
          if (time.includes('H') && time.includes('M')) {
            return time.split('H')[1].split('M')[0];
          } else {
            return time.slice(0, -1);
          }
        }
      },
    };
  },
  methods: {
    $_getFormattedSeconds(num) {
      return this.formatSeconds(num);
    },
    $_covertToSeconds(val) {
      return this.stringToSeconds(val);
    },
    $_getTimeUnit(seconds) {
      return this.timeUnit(seconds);
    },
    $_stripZeros(val) {
      return this.removeZeros(val);
    },
    $_getAbbreviatedTime(num) {
      return this.abbreviatedTime(num);
    },
    $_formatPrepTime(prepTime) {
      return this.formatPrepTime(prepTime);
    },
    $_getRecipePrepHours(prepTime) {
      return this.prepHours(prepTime);
    },
    $_getRecipePrepMinutes(prepTime) {
      return this.prepMinutes(prepTime);
    }
  },
};
